import { useFormContext } from 'react-hook-form';
import { MenuItem, Select } from 'ui';

import { SelectFieldProps, SelectOption } from '../SelectField/SelectField';

type BooleanSelectFieldProps = Omit<SelectFieldProps, 'options'> & {
  withNotAvailable?: boolean;
};

const DEFAULT_OPTIONS = [
  {
    label: 'Yes',
    value: 'true',
  },
  {
    label: 'No',
    value: 'false',
  },
];

const NOT_AVAILABLE_VALUE = 'n/a';

const OPTIONS_WITH_NOT_AVAILABLE = [
  ...DEFAULT_OPTIONS,
  {
    label: 'N/A',
    value: NOT_AVAILABLE_VALUE,
  },
];

const getDisplayedValue = (value: boolean | undefined, withNotAvailable: boolean) => {
  if (value === undefined) {
    return withNotAvailable ? NOT_AVAILABLE_VALUE : '';
  }
  return value.toString();
};

export const BooleanSelectField = ({ withNotAvailable = false, name, ...rest }: BooleanSelectFieldProps) => {
  const { setValue, watch } = useFormContext();
  const fieldValue = watch(name);
  const options = withNotAvailable ? OPTIONS_WITH_NOT_AVAILABLE : DEFAULT_OPTIONS;
  return (
    <Select
      id={name}
      name={name}
      {...rest}
      value={getDisplayedValue(fieldValue, withNotAvailable)}
      onChange={(e) => {
        switch (e.target.value) {
          case 'true':
            setValue(name, true);
            return;
          case 'false':
            setValue(name, false);
            return;
          default:
            setValue(name, undefined);
            return;
        }
      }}
    >
      {options.map((option: SelectOption) => (
        <MenuItem key={option.label} value={option.value}>
          {option.label}
        </MenuItem>
      ))}
    </Select>
  );
};
